export default __webpack_public_path__ + "static/media/7.86e415cc.png";